"use client";

import { handleShopifyLogin } from "@/lib/shopify/auth/customer-login";

export const ShopifyLogin = () => {
  return (
    <button
      onClick={handleShopifyLogin}
      className={`nav-link flex h-16 items-center border-r-1 border-primary px-6 text-primary`}
    >
      Login
    </button>
  );
};

export const ShopiyLoginMobile = () => {
  return (
    <button onClick={handleShopifyLogin} className="font-mono">
      Login
    </button>
  );
};
